import { Extension } from '@tiptap/core';
import { Plugin } from '@tiptap/pm/state';
import type { EditorView } from 'prosemirror-view';
import type { Slice } from 'prosemirror-model';

export const CustomDrop = Extension.create({
  name: 'custom-drop',

  addProseMirrorPlugins() {
    return [
      new Plugin({
        props: {
          handleDrop: (view: EditorView, event: DragEvent, _slice: Slice) => {
            if (!event.dataTransfer) {
              return false;
            }

            let data: any;

            try {
              data = JSON.parse(event.dataTransfer.getData('text/plain'));
            } catch {
              return false;
            }

            if (
              !data ||
              data.type !== 'object/insert' ||
              !Array.isArray(data.value)
            ) {
              return false;
            }

            const { state, dispatch } = view;
            const { selection } = state;
            const { from } = selection;

            let tr = state.tr;
            data.value.forEach((item: any) => {
              const content = item?.label
                ? `${item.label}`
                : `${item.container}:${item.uuid}`;

              const tokenNode = state.schema.nodes.token.create({
                content,
                'data-uuid': item.uuid,
                'data-type': item.type || 'node',
              });
              tr = tr.insert(from, tokenNode);
              tr = tr.insertText(' ', from + tokenNode.nodeSize);
            });
            dispatch(tr);

            setTimeout(() => {
              view.focus();
            }, 0);

            event.preventDefault();

            return true;
          },
        },
      }),
    ];
  },
});
